import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 500 500"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M218.647 405.787c-10.068 0-18.24-8.189-18.24-18.257s8.172-18.257 18.24-18.257h62.724c10.051 0 18.257 8.189 18.257 18.257s-8.206 18.257-18.257 18.257zm194.985-76.484c0-10.085 8.155-18.24 18.24-18.24 10.051 0 18.24 8.155 18.24 18.24v97.308c0 36.983-29.936 66.935-66.919 66.935H116.809c-36.95 0-66.92-29.935-66.92-66.935V179.02a66.93 66.93 0 0 1 25.338-52.438l133.184-105.63c24.365-19.331 58.814-19.331 83.162 0l133.184 105.63c16.008 12.703 25.355 32.017 25.355 52.438v52.941c0 10.068-8.206 18.257-18.257 18.257-10.085 0-18.257-8.189-18.257-18.257V179.02a30.39 30.39 0 0 0-11.528-23.828L268.887 49.562c-11.058-8.793-26.731-8.793-37.789 0L97.914 155.192a30.39 30.39 0 0 0-11.545 23.845v247.607c0 16.831 13.626 30.423 30.44 30.423h266.367c16.814 0 30.422-13.592 30.422-30.423z"
    }, null, -1)
  ])))
}
export default { render: render }